// The catalog's colour fields also carry lens types and finishes
// ("Transparent, Demo Lenses", "Blue Light Lenses", "Silver, Mirrored").
// Printed under "Colour" they would read as colours: "Blue / Blue Light
// Lenses" suggests blue lenses on a clear-lens frame.
const NON_COLOUR_TOKEN = /\blens(?:es)?\b|^(?:demo|mirror|mirrored)$/i;

/**
 * The colours in one catalog colour option ("Black,Crystal" → "Black,
 * Crystal"), without lens types and finishes. Kept on its own so the variant
 * rail's code, which every page loads for link prefetching, does not bring the
 * PDP's whole presentation module with it.
 */
export function colourList(value: string): string {
  return value
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item && !NON_COLOUR_TOKEN.test(item))
    .join(", ");
}

// Index of the slash that separates a frame colour from a lens colour inside
// one option, or -1. "W/" is the catalog's "with" ("Grey Crystal W/ Gold
// Flakes / Dark Grey"), not a separator. A plain loop instead of a lookbehind,
// which older Safari cannot parse.
export function framePairSlash(value: string): number {
  for (let i = value.indexOf("/"); i !== -1; i = value.indexOf("/", i + 1)) {
    if (!/(?:^|[^a-z])w$/i.test(value.slice(0, i))) return i;
  }
  return -1;
}
